<template>
    <div>
       <h2>{{translate('integrate_title', integration?.name)}}</h2>
       <p>
           {{translate('not_activatable')}}
       </p>
        <a :href="'/'+ language + '/integrations/contact/' + integration.id" class="btn mt-6 btn-primary">{{translate('btn_contact')}}</a>
    </div>
</template>

<script lang="ts">
    import { SoftwarePartner } from '../../../types/dto/SoftwarePartner';
    import {defineComponent} from 'vue';
    import {Language} from "../../../types/dto/Language";

    export default defineComponent({
        name: 'integration_not_activatable',
        props: {
            integration: Object as () => SoftwarePartner,
            language: String as () => Language
        }
    })
</script>